import React, { useEffect } from "react";
import "./Solution2.css";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import Firewall1 from "../../assest/solutions/Firewall 1.png";

const Firewall = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="resilience-container">
        {/* Hero Section */}
        <div className="hero-section">
          <div className="hero-content">
            <div className="backup-container">
              <a href="/solutions#Security" className="backup-text">
                Solution
              </a>
              <p>/Firewall​</p>
            </div>

            <div className="hero-wrapper">
              <div className="hero-text-container">
                <div className="hero-text-content">
                  <h1 className="hero-title">
                    <span className="hero-title-main">Firewall​</span>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content">
          <div className="boost-productivity-container">
            <p className="boost-productivity-text">
              <b>Protecting Your Digital Assets :</b>
            </p>
            <p className="boost-productivity-text">
              Firewalls are a critical component of any comprehensive
              cybersecurity strategy, acting as the first line of defense
              against unauthorized access and malicious threats. At Proscope, we
              offer cutting-edge firewall solutions designed to safeguard your
              digital assets and ensure the integrity, confidentiality, and
              availability of your data.​​
            </p>

            <p className="boost-productivity-text">
              <b>What is a Firewall?​ ​</b>
            </p>
            <p className="boost-productivity-text">
              Our Firewall Solutions At Proscope, we understand the importance
              of robust firewall protection in today's dynamic threat landscape.
              Our firewall solutions are tailored to meet the unique security
              needs of your organization, providing comprehensive protection
              against a wide range of cyber threats, including:​​​​
            </p>
            <p className="boost-productivity-text">
              1.Malware and ransomware attacks​
            </p>
            <p className="boost-productivity-text">
              2.Unauthorized access attempts​
            </p>
            <p className="boost-productivity-text">
              3.Denial-of-service (DoS) attacks​
            </p>
            <p className="boost-productivity-text">4.Intrusion attempts​</p>
            <p className="boost-productivity-text">
              5.Data exfiltration and leakage​
            </p>

            <p className="boost-productivity-text">
              <b>Key Features and Benefits​ :</b>
            </p>
            <p className="boost-productivity-text">
              1.Our firewall solutions offer a range of features and benefits to
              enhance your organization's security posture, including:
            </p>
            <p className="boost-productivity-text">
              2.Advanced threat detection and prevention capabilities​​
            </p>
            <p className="boost-productivity-text">
              3.Granular access controls and policy enforcement​​
            </p>
            <p className="boost-productivity-text">
              4.Intrusion detection and prevention systems (IDPS)​​
            </p>
            <p className="boost-productivity-text">
              5.Application-layer filtering and content inspection​​
            </p>
            <p className="boost-productivity-text">
              6.Secure remote access and VPN connectivity​​
            </p>
            <p className="boost-productivity-text">
              7.Centralized management and reporting​
            </p>
            <p className="boost-productivity-text">
              <b>Why Choose Proscope?​​</b>
            </p>
            <p className="boost-productivity-text">
              With Proscope, you can trust that your privileged access
              management needs are in good hands. Our team of cybersecurity
              experts brings years of experience and expertise to the table,
              ensuring that your organization's critical assets remain protected
              against evolving threats. We work closely with you to understand
              your unique security requirements and tailor our PAM solutions to
              meet your specific objectives.{" "}
            </p>
            <img src={Firewall1} className="centered-image" alt="Firewall" />

            <p className="boost-productivity-text">
              <b>Get Started Today​ :</b>
            </p>
            
            <p className="boost-productivity-text">
              Protect your organization from cyber threats with our advanced
              firewall solutions by Fortinet. Contact us today to learn more
              about our services and schedule a consultation with one of our
              cybersecurity specialists. Don't wait until it's too late –
              safeguard your digital assets with Proscope's firewall solutions​.
            </p>
          </div>
        </div>

        <div className="software-contact-button-wrapper">
          <a
            href="/contactus?subject=Firewall"
            className="software-contact-button"
          >
            Contact Us
          </a>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Firewall;
